var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVibeAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232",
    transform: "translate(2252.427 2559.821)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(-2252.427 -2559.821)",
    fill: "#00b4bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(-2241.888 -2536.242)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    cx: 1.223,
    cy: 1.223,
    r: 1.223,
    transform: "translate(23.753 8.527)",
    fill: "#5d7d84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M111.969,25.45a5.711,5.711,0,1,1,4.937-8.566,1.012,1.012,0,0,1-.326,1.357l-4.012,2.61a1.014,1.014,0,1,1-1.1-1.7l3.1-2.02a3.684,3.684,0,1,0-.764,5.795,1.013,1.013,0,0,1,1.013,1.755A5.645,5.645,0,0,1,111.969,25.45Z",
    transform: "translate(-73.928 -9.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M48.663,25.4a1.013,1.013,0,0,1-1.013-1.013V14.913a1.013,1.013,0,1,1,2.026,0v9.476A1.011,1.011,0,0,1,48.663,25.4Z",
    transform: "translate(-33.157 -9.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M69.05,15.69a5.716,5.716,0,0,1-5.71-5.71V1.013a1.013,1.013,0,0,1,2.026,0V9.978A3.684,3.684,0,1,0,69.05,6.3a1.013,1.013,0,0,1,0-2.026,5.71,5.71,0,1,1,0,11.42Z",
    transform: "translate(-44.074 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M6.4,25.4H6.395A2.5,2.5,0,0,1,4.2,24.086a.364.364,0,0,1-.024-.049L.1,15.34a1.013,1.013,0,0,1,1.834-.861L6,23.143a.451.451,0,0,0,.4.228h0a.457.457,0,0,0,.4-.225l4.076-8.67a1.015,1.015,0,1,1,1.837.864L8.624,24.047,8.6,24.1A2.5,2.5,0,0,1,6.4,25.4Z",
    transform: "translate(-0.005 -9.667)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibeAppIcon);
export default __webpack_public_path__ + "static/media/Vibe_app_icon.51d553483863d69f72466f846fabc6d0.svg";
export { ForwardRef as ReactComponent };